export const machineryAux = [
  {
    name: 'machinery_aux_info',
    value: '',
    type: 'textarea',
    placeholder: 'INFO',
    className: 'mt-2'
  }
];
